import { RadarChart, PolarGrid, PolarAngleAxis, PolarRadiusAxis, Radar, ResponsiveContainer, Tooltip } from 'recharts';

/**
 * 六维雷达图（公共组件）
 * 样式规范定稿于 2026-09-12（体检报告）：满分=外圈撑满（固定 0-100 径向值域）、
 * 浅灰正六边形满分参考底（PolarGrid fill）、实际分数=半透明绿面积+绿点端点。
 * 原实现位于 xhs-diagnosis.tsx，2026-09-15 提取为公共组件供 IP人设/体检复用。
 */
export function SixDimRadar({ dimensions, title = '六维雷达图' }: { dimensions: Record<string, any>; title?: string }) {
  const entries = Object.entries(dimensions || {});
  const data = entries.map(([k, v]) => ({
    key: k,
    dim: v?.name || k,
    score: typeof v?.score === 'number' ? v.score : 0,
    hasScore: typeof v?.score === 'number',
  }));
  const hasAny = data.some((d) => d.hasScore);
  if (!hasAny || data.length === 0) return null;
  return (
    <div className="rounded-lg border p-4">
      <div className="mb-2 text-sm font-medium">{title}</div>
      <ResponsiveContainer width="100%" height={280}>
        <RadarChart data={data} outerRadius="72%">
          {/* 满分参考底：100分撑满的正六边形（浅灰轮廓 + 内部浅灰填充）+ 中心到顶点向量轴 */}
          <PolarGrid
            stroke="var(--muted-foreground)"
            strokeOpacity={0.35}
            fill="var(--muted-foreground)"
            fillOpacity={0.12}
          />
          {/* 固定径向值域 0-100：75 分正好在 3/4 位置，不满 100 不会被撑满外圈 */}
          <PolarRadiusAxis domain={[0, 100]} tick={false} axisLine={false} />
          <PolarAngleAxis dataKey="dim" tick={{ fontSize: 12, fill: 'var(--muted-foreground)' }} />
          <Tooltip
            contentStyle={{ background: 'var(--card)', border: '1px solid var(--border)', fontSize: 12 }}
            formatter={(value: any, _name: any, item: any) => {
              const d = item?.payload;
              return [d?.hasScore ? `${value} 分` : '数据不足', d?.dim];
            }}
          />
          {/* 实际分数：在每条向量轴上按实际分数量化定位，绿色端点连成半透明绿色面积 */}
          <Radar
            name="评分"
            dataKey="score"
            stroke="#10b981"
            fill="#10b981"
            fillOpacity={0.2}
            strokeWidth={2}
            dot={{ r: 4.5, fill: '#10b981', stroke: 'var(--background)', strokeWidth: 1.5 }}
            activeDot={{ r: 6, fill: '#10b981' }}
          />
        </RadarChart>
      </ResponsiveContainer>
      <p className="mt-1 text-center text-xs text-muted-foreground">评分为代理指标，0 表示该维度数据不足（未计入平均）</p>
    </div>
  );
}
